/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlFormProgress
 */
export interface ControlFormProgress {
    /**
     * 
     * @type {number}
     * @memberof ControlFormProgress
     */
    total_questions: number;
    /**
     * 
     * @type {number}
     * @memberof ControlFormProgress
     */
    in_progress_questions: number;
    /**
     * 
     * @type {number}
     * @memberof ControlFormProgress
     */
    completed_questions: number;
}

/**
 * Check if a given object implements the ControlFormProgress interface.
 */
export function instanceOfControlFormProgress(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "total_questions" in value;
    isInstance = isInstance && "in_progress_questions" in value;
    isInstance = isInstance && "completed_questions" in value;

    return isInstance;
}

export function ControlFormProgressFromJSON(json: any): ControlFormProgress {
    return ControlFormProgressFromJSONTyped(json, false);
}

export function ControlFormProgressFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlFormProgress {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'total_questions': json['total_questions'],
        'in_progress_questions': json['in_progress_questions'],
        'completed_questions': json['completed_questions'],
    };
}

export function ControlFormProgressToJSON(value?: ControlFormProgress | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total_questions': value.total_questions,
        'in_progress_questions': value.in_progress_questions,
        'completed_questions': value.completed_questions,
    };
}

